var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('table-render',{ref:"tableRender",staticStyle:{"padding":"0"},attrs:{"propData":_vm.propData,"config":_vm.config,"rowKey":"id"}})}
var staticRenderFns = []

export { render, staticRenderFns }